import { render, staticRenderFns } from "./FaqAndSupportContactsCard.vue?vue&type=template&id=04b4c70a&scoped=true"
import script from "./FaqAndSupportContactsCard.vue?vue&type=script&lang=js"
export * from "./FaqAndSupportContactsCard.vue?vue&type=script&lang=js"
import style0 from "./FaqAndSupportContactsCard.vue?vue&type=style&index=0&id=04b4c70a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4c70a",
  null
  
)

export default component.exports